import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import SectionBanner from "../../utils/SectionBanner";
import DocumentGroupRow from "./DocumentGroupRow";

class DocumentGroup extends Component {
	render() {
		const { translations, group } = this.props;

		return (
			<div className="section-row section-row--block">
				<SectionBanner>{group.title}</SectionBanner>
				<div className="padded-content">
					{group.files.length ? (
						group.files.map((file, i) => <DocumentGroupRow key={i} file={file} />)
					) : (
						<div>{translations.sections.training_videos.no_files_response}</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(DocumentGroup);



// WEBPACK FOOTER //
// ./src/components/training/documents/DocumentGroup.js